// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mCv2","clinicsSelect":"styles_clinicsSelect__3yLzL"};